import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "user-item-view" }
const _hoisted_2 = { class: "subheader" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb-current" }
const _hoisted_5 = {
  key: 0,
  class: "state-message"
}
const _hoisted_6 = {
  key: 1,
  class: "state-message state-message--error"
}
const _hoisted_7 = {
  key: 2,
  class: "state-message state-message--error"
}
const _hoisted_8 = {
  key: 3,
  class: "content"
}
const _hoisted_9 = { class: "right-area" }

import { computed, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useUsers } from "@/composables/useUsers";
import UserProfileCard from "@/components/user/UserProfileCard.vue";
import UserStatCards from "@/components/user/UserStatCards.vue";
import UserAccountDetails from "@/components/user/UserAccountDetails.vue";
import BaseIcon from "@/components/ui/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserItemView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { users, loading, error, fetchUsers } = useUsers();

onMounted(fetchUsers);

const user = computed(() => {
  const id = Number(route.params.id);
  return users.value.find((u) => u.id === id) ?? null;
});

watch(user, (val) => {
  document.title = val ? `${val.fullName} — Pulse` : "Pulse";
});

const totalLogins = computed(() => (user.value ? user.value.id * 17 + 42 : 0));

const sessions = computed(() => (user.value ? (user.value.id % 8) + 1 : 0));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/users')))
      }, [
        _createVNode(BaseIcon, {
          name: "arrow-left",
          size: 15
        }),
        _cache[1] || (_cache[1] = _createTextVNode(" Back to Users ", -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "breadcrumb-parent" }, "Users", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "breadcrumb-sep" }, "/", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(user.value?.fullName ?? "..."), 1)
      ])
    ]),
    (_unref(loading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Loading..."))
      : (_unref(error))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(error)), 1))
        : (!user.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " User not found. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(UserProfileCard, { user: user.value }, null, 8, ["user"]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(UserStatCards, {
                  "total-logins": totalLogins.value,
                  "last-login": user.value.lastLogin,
                  "is-logged-in": user.value.isLoggedIn,
                  sessions: sessions.value
                }, null, 8, ["total-logins", "last-login", "is-logged-in", "sessions"]),
                _createVNode(UserAccountDetails, { user: user.value }, null, 8, ["user"])
              ])
            ]))
  ]))
}
}

})